var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackLeftLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 77,
    viewBox: "0 0 19 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20509 1.52246C8.13893 5.12848 15.351 4.47284 17.8922 3.8172C19.3037 33.321 16.9088 52.0067 16.2531 57.9075C15.7286 62.6281 16.9178 67.5235 17.4642 68.7255C18.7404 72.0037 19.0684 73.315 17.4642 74.6263C15.986 75.8346 7.41109 76.0468 2.71234 75.6098C0.710468 75.4235 0.0548286 74.6263 1.07324 73.315C4.48256 71.217 5.62777 72.0037 7.26687 68.7255C8.25033 67.0864 8.21537 58.2353 7.26686 54.9571C1.00334 40.2052 4.20509 11.0292 4.20509 1.52246Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLeftLeg);
export default __webpack_public_path__ + "static/media/BackLeftLeg.34d607a570354a8d4471b01ae7c214c3.svg";
export { ForwardRef as ReactComponent };